import './shannondellwick/style';
import FormStructure from './shannondellwick/form_structure';

export default FormStructure;